import { makeStyles } from "@material-ui/core";
import clsx from "clsx";
import React, { useEffect, useRef, useState } from "react";
import { motion } from "framer-motion";
import TruestedSection from "../components/v4/TrustedSection/TruestedSection";
import LazyImage from "../components/v4/LazyLoadImage/LazyImage";
import LottieIcon from "../components/v4/LottieIcon";
import FaqSection from "../components/v4/FaqSection/FaqSection";
import Link from "../components/v2/Link";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/autoplay";

import greenCheckCircle from "../images/v4/whatsappPage/icons/greenCheckCircle.svg";

import detailImg1 from "../images/v4/aiSalesCrm/images/detailImg1.webp";
import detailImg2 from "../images/v4/aiSalesCrm/images/detailImg2.webp";

import heroSectionBg from "../images/v4/aiSalesCrm/images/heroSectionBg.png";
import bentoSectionBg from "../images/v4/aiSalesCrm/images/bentoSectionBg.png";
import heroSectionImg from "../images/v4/aiSalesCrm/images/heroSectionImg.webp";

import swiperCardBg from "../images/v4/aiSalesCrm/images/swiperCardBg.png";

import benifitListIcon1 from "../images/v4/aiSalesCrm/icons/benifitListIcon1.svg";
import benifitListIcon2 from "../images/v4/aiSalesCrm/icons/benifitListIcon2.svg";
import benifitListIcon3 from "../images/v4/aiSalesCrm/icons/benifitListIcon3.svg";
import benifitListIcon4 from "../images/v4/aiSalesCrm/icons/benifitListIcon4.svg";
import benifitListIcon5 from "../images/v4/aiSalesCrm/icons/benifitListIcon5.svg";
import benifitListIcon6 from "../images/v4/aiSalesCrm/icons/benifitListIcon6.svg";

import benefitImage1 from "../images/v4/aiSalesCrm/images/benefitImage1.webp";
import benefitImage2 from "../images/v4/aiSalesCrm/images/benefitImage2.webp";
import benefitImage3 from "../images/v4/aiSalesCrm/images/benefitImage3.webp";
import benefitImage4 from "../images/v4/aiSalesCrm/images/benefitImage4.webp";
import benefitImage5 from "../images/v4/aiSalesCrm/images/benefitImage5.webp";
import benefitImage6 from "../images/v4/aiSalesCrm/images/benefitImage6.webp";

import realWorldImg1 from "../images/v4/aiSalesCrm/images/realWorldImg1.webp";
import realWorldImg2 from "../images/v4/aiSalesCrm/images/realWorldImg2.webp";
import realWorldImg3 from "../images/v4/aiSalesCrm/images/realWorldImg3.webp";
import realWorldImg4 from "../images/v4/aiSalesCrm/images/realWorldImg4.webp";
import realWorldImg5 from "../images/v4/aiSalesCrm/images/realWorldImg5.webp";

import bentoImg1 from "../images/v4/aiSalesCrm/images/bentoImg1.webp";
import bentoImg2 from "../images/v4/aiSalesCrm/images/bentoImg2.webp";
import bentoImg3 from "../images/v4/aiSalesCrm/images/bentoImg3.webp";
import bentoImg4 from "../images/v4/aiSalesCrm/images/bentoImg4.webp";
import bentoImg5 from "../images/v4/aiSalesCrm/images/bentoImg5.webp";
import bentoImg5Mob from "../images/v4/aiSalesCrm/images/bentoImg5Mob.webp";

import swiperIcon1 from "../images/v4/aiSalesCrm/icons/swiperIcon1.svg";
import swiperIcon2 from "../images/v4/aiSalesCrm/icons/swiperIcon2.svg";
import swiperIcon3 from "../images/v4/aiSalesCrm/icons/swiperIcon3.svg";
import swiperIcon4 from "../images/v4/aiSalesCrm/icons/swiperIcon4.svg";

import partnerIcon1 from "../images/v4/aiPage/icons/partnerIcon1.png";
import partnerIcon2 from "../images/v4/aiPage/icons/partnerIcon2.png";
import partnerIcon3 from "../images/v4/aiPage/icons/partnerIcon3.png";
import partnerIcon5 from "../images/v4/aiPage/icons/partnerIcon5.png";
import partnerIcon6 from "../images/v4/aiPage/icons/partnerIcon6.png";
import partnerIcon7 from "../images/v4/aiPage/icons/partnerIcon7.png";
import partnerIcon8 from "../images/v4/aiPage/icons/partnerIcon8.png";
import SEO from "../components/SEO";

const useStyles = makeStyles(() => ({
  detailSection: {
    background: "transparent",
    // "&.section3": {
    //   background: "linear-gradient(180deg, #001742 0%, #002C7E 100%)",
    // },
    // "&.section1": {
    //   background: "transparent",
    // },
  },
  detailCard: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
    "@media only screen and (max-width: 600px)": {
      flexDirection: "column",
      gap: "20px",
    },
    "&.detailCard3": {
      "@media only screen and (max-width: 600px)": {
        flexDirection: "column-reverse",
        gap: "32px",
      },
    },
  },
  detailCardLeft: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    gap: "20px",
    width: "auto",
    "&.card2": {
      width: "48%",
      backgroundRepeat: "no-repeat",
      backgroundImage: `url(${swiperCardBg})`,
      backgroundSize: "auto",
      backgroundPosition: "top",
      padding: "20px 20px 0",
      flexWrap: "wrap",
      flexDirection: "row",
      borderRadius: "16px 16px 0 0",
    },
    "@media only screen and (max-width: 600px)": {
      width: "100%",
      "&.card2": {
        width: "100%",
        padding: "0",
        backgroundImage: "none",
        gap: "15px",
        marginTop: "24px",
      },
    },
  },
  detailCardRight: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    gap: "20px",
    width: "48%",
    "@media only screen and (max-width: 600px)": {
      width: "100%",
    },
  },
  benfitListContainer: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    paddingBottom: "200px",
    "@media only screen and (max-width: 600px)": {
      paddingBottom: "60px",
    },
  },
  benfitListItemOuter: {
    background: "#fff",
    padding: "20px",
    width: "100%",
    transition: "0.5s ease",
    "&:hover": {
      // background: $(--hover-bg-color),
      "& $absoluteImage": {
        opacity: 1,
        visibility: "visible",
      },
    },
    "@media only screen and (max-width: 600px)": {
      "&.active": {
        background: "transparent",
      },
      padding: "10px 15px",
    },

    "&.active": {
      "& $absoluteImage": {
        opacity: 1,
        visibility: "visible",
      },
    },
  },
  benfitListItem: {
    display: "flex",
    width: "90%",
    maxWidth: "1200px",
    margin: "0 auto",
    justifyContent: "flex-start",
    alignItems: "center",
    gap: "40px",
    position: "relative",
    "@media only screen and (max-width: 600px)": {
      width: "100%",
      gap: "15px",
      alignItems: "flex-start",
    },
  },
  benfitListItemContent: {
    display: "flex",
    flexDirection: "column",
    width: "40%",
    gap: "10px",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    "@media only screen and (max-width: 600px)": {
      width: "100%",
    },
  },
  benfitIcon: {
    width: "55px",
    "@media only screen and (max-width: 600px)": {
      width: "40px",
    },
  },
  absoluteImage: {
    position: "absolute",
    right: "0",
    width: "auto",
    height: "auto",
    opacity: 0,
    visibility: "hidden",
    transition: "0.5s ease",
    borderRadius: "32px",
    "@media only screen and (max-width: 600px)": {
      display: "none",
    },
  },
  benfitSection: {
    paddingBottom: "150px",
    "& $aiSectionLeft": {
      width: "43%",
    },
    "@media only screen and (max-width: 600px)": {
      // paddingBottom: "0",
      "& $aiSectionLeft": {
        width: "100%",
      },
    },
  },
  aiSectionLeft: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    width: "40%",
    gap: "20px",
    "@media only screen and (max-width: 600px)": {
      width: "100%",
    },
  },
  aiSectionRight: {
    width: "40%",
    "@media only screen and (max-width: 600px)": {
      width: "100%",
    },
  },
  absoulteCard: {
    position: "absolute",
    margin: "0 auto",
    width: "100%",
    top: "-20%",
    "@media only screen and (max-width: 600px)": {
      top: "-15%",
    },
  },
  tabsSection: {
    position: "relative",
    background: "#E0EFFD",
    paddingTop: "300px",
    "& .centerContainer": {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      gap: "32px",
      width: "100%",
      margin: "0 auto",
      textAlign: "center",
    },
    "& $supportBox": {
      position: "absolute",
      top: "-530px",
      "@media only screen and (max-width: 600px)": {
        top: "-800px",
        marginTop: 0,
      },
    },
    "@media only screen and (max-width: 600px)": {
      paddingTop: "150px",
      "& .centerContainer": {
        width: "100%",
      },
    },
  },
  tabsContainer: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "8px",
    border: "2px solid #DBDBDB",
    borderRadius: "40px",
    background: "#fff",
    "@media only screen and (max-width: 600px)": {
      width: "100%",
      gap: "10px",
      padding: "5px",
      overflow: "auto",
      "&::-webkit-scrollbar": {
        display: "none",
      },
    },
  },
  tab: {
    width: "33%",
    background: "",
    padding: "18px",
    background: "transparent",
    borderRadius: "40px",
    background: "transparent",
    transition: "0.3s ease",
    cursor: "pointer",
    "&.active": {
      color: "white",
      background:
        "linear-gradient(90deg, #FF682A 0%, #FF7056 35%, #FF682A 73%, #FF550F 100%)",
    },
    "@media only screen and (max-width: 600px)": {
      minWidth: "max-content",
      padding: "10px 15px",
    },
  },
  tabCard: {
    marginTop: "65px",
    gap: "40px",
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    "@media only screen and (max-width: 600px)": {
      marginTop: "30px",
      flexDirection: "column",
    },
  },
  tabCardLeftContainer: {
    width: "50%",
    display: "flex",
    gap: "40px",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    "@media only screen and (max-width: 600px)": {
      gap: "20px",
      width: "100%",
    },
  },
  tabCardRightContainer: {
    width: "60%",
    "@media only screen and (max-width: 600px)": {
      width: "100%",
    },
  },

  tabListContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    gap: "30px",
    marginTop: "50px",
    "@media only screen and (max-width: 600px)": {
      gap: "15px",
      marginTop: "20px",
    },
  },
  tabListItem: {
    display: "flex",
    width: "100%",
    margin: "0 auto",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    gap: "15px",
    position: "relative",
    "@media only screen and (max-width: 600px)": {
      width: "100%",
      gap: "15px",
      alignItems: "flex-start",
    },
  },
  tabListItemContent: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    gap: "10px",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    "@media only screen and (max-width: 600px)": {
      width: "100%",
    },
  },
  wpFaq: {
    // paddingTop: "120px",
    "@media only screen and (max-width: 600px)": {
      "& section": {
        padding: "0px 0 0 !important",
      },
    },
  },
  bentoSection: {
    backgroundImage: `url(${bentoSectionBg})`,
    backgroundPosition: "center",
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
  },
  bentoSectionContainer: {
    width: "100%",
    height: "100%",
    gap: "20px",
    display: "flex",
    alignItems: "stretch",
    justifyContent: "flex-start",
    "@media only screen and (max-width: 600px)": {
      flexDirection: "column",
    },
  },
  bentoTab: {
    gap: "20px",
    display: "flex",
    flexDirection: "column",
    alignItems: "stretch",
    justifyContent: "flex-start",

    "&:nth-child(1)": {
      width: "24%",
      height: "auto",
    },
    "&:nth-child(2)": {
      width: "32%",
      height: "auto",
      flexDirection: "row",
    },
    "&:nth-child(3)": {
      width: "40%",
      height: "auto",
    },
    "@media only screen and (max-width: 600px)": {
      width: "100% !important",
    },
  },
  bentoCard: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    width: "100%",
    borderRadius: "16px",
    padding: "24px",
    gap: "16px",
    height: "100%",
    position: "relative",
    "& .cardInner": {
      display: "flex",
      flexDirection: "column",
      justifyContent: "flex-start",
      alignItems: "flex-start",
      gap: "24px",
    },
    "&.card1": {
      paddingBottom: "0",

      "& img": {
        position: "relative",
        bottom: "0",
        width: "100%",
      },
      background: "linear-gradient(127deg, #FFF4E3 0%, #FFD59A 100%);",
      "@media only screen and (max-width: 600px)": {
        "& img": {
          position: "relative",
        },
      },
    },
    "&.card2": {
      paddingBottom: "10px",
      justifyContent: "center",
      alignItems: "center",
      background: "linear-gradient(129deg, #D5FFFF 0%, #3FE9E9 100%)",
    },
    "&.card3": {
      "& img": {
        position: "absolute",
        left: "0",
        bottom: "0",
        "@media only screen and (max-width: 600px)": {
          position: "absolute",
          width: "90%",
        },
      },
      paddingBottom: "0",
      background: "linear-gradient(152deg, #F1DFFF 0%, #B570EE 100%)",
      "@media only screen and (max-width: 600px)": {
        "& img": {
          width: "100%",
          position: "relative",
        },
      },
      "@media only screen and (max-width: 600px)": {
        height: "490px",
      },
    },
    "&.card4": {
      paddingBottom: "0",
      "& img": {
        position: "relative",
        width: "100%",
        right: "-6%",
        "@media only screen and (max-width: 600px)": {
          right: "-10%",
        },
      },
      background: "linear-gradient(115deg, #FFE8D9 0%, #FF934A 100%)",
      "@media only screen and (max-width: 600px)": {
        "& img": {
          position: "relative",
          width: "100%",
        },
      },
    },
    "&.card5": {
      flexDirection: "row",
      padding: "0 24px",
      alignItems: "stretch",
      background: "linear-gradient(96deg, #C0E3FF 0%, #51AEFF 100%)",
      "& .mobImg": {
        display: "none",
      },
      "& .cardInner": {
        padding: "16px 0",
      },
      "@media only screen and (max-width: 600px)": {
        padding: "0",
        alignItems: "center",
        "& .cardInner": {
          width: "60%",
          padding: "20px",
          paddingRight: "0",
        },
        "& .webImg": {
          display: "none",
        },
        "& .mobImg": {
          width: "40%",
          display: "block",
        },
      },
    },
  },
  mainSection: {
    backgroundImage: `url(${heroSectionBg})`,
    backgroundPosition: "bottom",
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
  },
  heroSection: {
    paddingTop: "80px",
    "@media only screen and (max-width: 600px)": {
      paddingTop: "0px",
    },
  },
  heroSectionContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
    "@media only screen and (max-width: 600px)": {
      flexDirection: "column",
      gap: "50px",
    },
  },
  leftContainer: {
    width: "45%",
    gap: "16px",
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    "@media only screen and (max-width: 600px)": {
      width: "100%",
    },
  },
  leftHeader: {
    width: "70%",
    background:
      "linear-gradient(90deg, rgba(0, 38, 109, 0.00) 0%, #00266D 100%)",
    borderRadius: "65px",
    border: "1px solid #2d5d8d",
    "@media only screen and (max-width: 600px)": {
      width: "80%",
    },
  },
  carouselSlide: {
    padding: "0 5px",
    display: "flex !important",
    alignItems: "center",
    justifyContent: "flex-start",
    gap: "10px",
    width: "max-content !important",
  },
  carouselText: {
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
    background:
      "linear-gradient(90deg, #F3FEFF 0.03%, #00E5FF 35.47%, #51FFCE 89.92%)",
  },
  leftBody: {
    gap: "16px",
    gap: "20px",
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    "& span": {
      background: "linear-gradient(to bottom right, #89D6FF 0%, #42FFF9 50%)",
      WebkitBackgroundClip: "text",
      WebkitTextFillColor: "transparent",
    },
  },
  rightContainer: {
    width: "45%",
    "@media only screen and (max-width: 600px)": {
      width: "100%",
      display: "none",
    },
  },
  leftFooter: {
    width: "100%",
  },
  stripSection: {
    marginTop: "60px",
    "& .centerContainer": {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    "@media only screen and (max-width: 600px)": {
      "& .centerContainer": {
        textAlign: "center",
      },
    },
  },
  partnerSlide: {
    width: "100px !important",
    "& img": {
      width: "100px",
      filter: "brightness(1)",
    },
    "@media only screen and (max-width: 600px)": {
      width: "140px !important",
      marginRight: "30px !important",
      "& img": {
        width: "140px",
        filter: "brightness(1)",
      },
    },
  },
  partnerSlider: {
    padding: "20px 0 0 !important",
    "@media only screen and (max-width: 600px)": {
      paddingBottom: "0 !important",
    },
  },
  textSlider: {
    padding: "10px 0 !important",
  },
  swiperCard: {
    width: "48%",
    padding: "32px 24px",
    borderRadius: "16px",
    height: "250px",
    overflow: "hidden",
    transition: "0.5s ease",
    "& .mainCard": {
      top: "0%",
      height: "-webkit-fill-available",
      display: "flex",
      textAlign: "center",
      alignItems: "center",
      justifyContent: "center",
      flexDirection: "column",
      gap: "24px",
      position: "relative",
      transition: "0.5s ease",
      visibility: "visible",
      opacity: "1",
      "& p": {
        display: "none",
      },
      "@media only screen and (max-width: 600px)": {
        gap: "15px",
        justifyContent: "flex-start",
        "& p": {
          display: "block",
        },
      },
    },
    "& .hoverCard": {
      bottom: "-50%",
      height: "-webkit-fill-available",
      textAlign: "center",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      flexDirection: "column",
      position: "relative",
      transition: "0.5s ease",
      visibility: "hidden",
      opacity: "0",
      "@media only screen and (max-width: 600px)": {
        display: "none",
      },
    },
    "&:hover": {
      "& .mainCard": {
        top: "-150%",
        visibility: "hidden",
        opacity: "0",
      },
      "& .hoverCard": {
        bottom: "100%",
        visibility: "visible",
        opacity: "1",
      },
    },
    "@media only screen and (max-width: 600px)": {
      width: "47%",
      padding: "15px",
      "&:hover": {
        "& .hoverCard": {
          display: "none !important",
        },
        "& .mainCard": {
          top: "0% !important",
          visibility: "visible !important",
          opacity: "1 !important",
        },
      },
    },
  },
  bentoSectionHeader: {
    marginBottom: "50px",
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "space-between",
    "@media only screen and (max-width: 600px)": {
      flexDirection: "column",
      gap: "20px",
    },
  },
  bentoSectionHeaderLeft: {
    width: "50%",
    "@media only screen and (max-width: 600px)": {
      width: "100%",
    },
  },
  bentoSectionHeaderRight: {
    width: "40%",
    "@media only screen and (max-width: 600px)": {
      width: "100%",
    },
  },
  commonPageFooterSection: {
    background:
      " linear-gradient(90deg, #011D32 0%, #00182B 100%) 0% 0% no-repeat padding-box",
    "& .centerContainer": {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      gap: "32px",
      width: "80%",
      margin: "0 auto",
      textAlign: "center",
    },
    "@media only screen and (max-width: 600px)": {
      "& .centerContainer": {
        width: "100%",
      },
    },
  },
  dot: {
    height: "10px",
    width: "10px",
    borderRadius: "50%",
    background:
      "linear-gradient(90deg, #F3FEFF 0.03%, #00E5FF 35.47%, #51FFCE 89.92%)",
  },
}));

const AiSalesCrm = () => {
  //declare
  const classes = useStyles();
  const [activeView, setActveView] = useState(0);
  const [activeRealWorld, setActiveRealWorld] = useState(0);

  //data
  const benfitList = [
    {
      icon: benifitListIcon1,
      heading: "Boost productivity through automation",
      content:
        "Automate lead creation, follow-ups, and call logging with AssistAI. This frees up your sales team to focus more on building relationships and closing deals.",
      image: benefitImage1,
      alt: "Boost productivity through automation",
      bgColor: "#F1DFFF",
      alt: "All-in-one CRM",
    },
    {
      icon: benifitListIcon2,
      heading: "Smarter conversations with AI-powered tools",
      content:
        "AssistAI rephrases messages, summarises chats, and sets the right tone. It shows how AI within CRM helps sales representatives communicate better and faster.",
      image: benefitImage2,
      alt: "Smarter conversations with AI-powered tools",
      bgColor: "#CEE9FF",
      alt: "Omnichannel CRM",
    },
    {
      icon: benifitListIcon3,
      heading: "Data-driven decisions and AI forecasting",
      content:
        "Real-time dashboards and predictive insights highlight what’s working. With CRM AI for sales, your team makes informed choices that lead to more wins.",
      image: benefitImage3,
      alt: "Data-driven decisions and AI forecasting",
      bgColor: "#FFE9DA",
      alt: "Sales management",
    },
    {
      icon: benifitListIcon4,
      heading: "Mobile access for on-the-go selling",
      content:
        "Stay connected with leads and pipelines anytime via the mobile app. The AI CRM for sales ensures productivity doesn’t stop when you're away from your desk.",
      image: benefitImage4,
      alt: "Mobile access for on-the-go selling",
      bgColor: "#BEE7E7",
      alt: "Activity management",
    },
    {
      icon: benifitListIcon5,
      heading: "Built-in compliance and data security",
      content:
        "Enterprise-grade security protects all customer interactions and records. Pepper Cloud’s AI CRM is fully encrypted and PDPA-compliant by design.",
      image: benefitImage5,
      alt: "Built-in compliance and data security",
      bgColor: "#CEE9FF",
      alt: "Workflow automation",
    },
    {
      icon: benifitListIcon6,
      heading: "Stronger follow-ups and improved conversions",
      content:
        "Set automated reminders and nudges never to miss a follow-up. This helps increase deal closures and trust—making it the best AI CRM for sales teams.",
      image: benefitImage6,
      alt: "Stronger follow-ups and improved conversions with AI CRM",
      bgColor: "#FFEDD2",
      alt: "AI CRM",
    },
  ];

  const tabContentData = [
    {
      tabContent: [
        {
          title: "Appointment booking flows",
          content:
            "Automate appointment confirmations and reminders via WhatsApp or SMS.",
          alt: "WhatsApp CRM for customer service",
        },
        {
          title: "AI-assisted queries",
          content:
            "Answer common patient questions instantly through AI chatbots.",
          alt: "WhatsApp CRM for customer service",
        },
        {
          title: "Centralised communication",
          content:
            "Store and manage patient interactions across all communication platforms.",
          alt: "WhatsApp CRM for customer service",
        },
        {
          title: "Follow-up reminders",
          content:
            "Notify staff about prescription refills or recheck appointments with CRM reminders.",
          alt: "WhatsApp CRM for customer service",
        },
        {
          title: "Secure and compliant",
          content:
            "Maintain patient confidentiality with data encryption and role-based access.",
          alt: "WhatsApp CRM for customer service",
        },
      ],
      img: realWorldImg1,
      alt: "WhatsApp CRM for customer service",
      subtitle:
        "Manage patient communications and appointment scheduling with automation. Use AI for sales and CRM to simplify administrative work and deliver a better patient experience.",
    },
    {
      tabContent: [
        {
          title: "Auto-capture from portals",
          content:
            "Leads from ads and property sites are directly added to CRM.",
          alt: "WhatsApp CRM for customer service",
        },
        {
          title: "Virtual tour scheduling",
          content:
            "AI sends calendar invites and reminders to interested buyers.",
          alt: "WhatsApp CRM for customer service",
        },
        {
          title: "Lead scoring by intent",
          content:
            "AI prioritises hot leads based on inquiry history and behaviour.",
          alt: "WhatsApp CRM for customer service",
        },
        {
          title: "WhatsApp catalogues",
          content: "Share listings and updates via broadcast templates.",
          alt: "WhatsApp CRM for customer service",
        },
        {
          title: "Pipeline tracking",
          content:
            "Visual dashboards show deal status, response time, and agent performance.",
          alt: "WhatsApp CRM for customer service",
        },
      ],
      img: realWorldImg2,
      alt: "WhatsApp CRM for customer service",
      subtitle:
        "Engage leads across channels and automate follow-ups for faster deal closures. Let CRM AI for sales organise your leads, property listings, and interactions in one place.",
    },
    {
      tabContent: [
        {
          title: "Campaign automation",
          content:
            "Share course info and deadlines via email and WhatsApp flows.",
          alt: "AI Sales CRM for Education",
        },
        {
          title: "Lead-to-enrolment tracking",
          content: "Follow every student from first click to conversion.",
          alt: "AI Sales CRM for Education",
        },
        {
          title: "Chatbot for queries",
          content: "AI handles FAQs about courses, fees, and admissions 24/7.",
          alt: "AI Sales CRM for Education",
        },
        {
          title: "Follow-up tasks",
          content:
            "I assigns counsellors to leads based on interest or channel.",
          alt: "AI Sales CRM for Education",
        },
        {
          title: "Mobile CRM for field teams",
          content: " Stay connected while attending school or college events.",
          alt: "AI Sales CRM for Education",
        },
      ],
      img: realWorldImg3,
      alt: "AI Sales CRM for Education",
      subtitle:
        "Nurture leads, schedule demos, and stay connected with students and parents. The best AI CRM for sales helps you personalise outreach at scale while staying organised.",
    },
    {
      tabContent: [
        {
          title: "Proposal follow-ups",
          content:
            " AI reminds reps to follow up on quotes and service queries.",
          alt: "AI Sales CRM for Professional Services",
        },
        {
          title: "Unified communication",
          content: "Handle email, WhatsApp, and call logs in one platform.",
          alt: "AI Sales CRM for Professional Services",
        },
        {
          title: "Contact enrichment",
          content: "AI suggests missing info based on conversation data.",
          alt: "AI Sales CRM for Professional Services",
        },
        {
          title: "Auto-log meetings",
          content:
            "Video or voice calls are recorded and summarised for reference.",
          alt: "AI Sales CRM for Professional Services",
        },
        {
          title: "Custom pipelines",
          content:
            "Tailor workflows for consulting, legal, finance, or recruitment",
          alt: "AI Sales CRM for Professional Services",
        },
      ],
      img: realWorldImg4,
      alt: "AI Sales CRM for Professional Services",
      subtitle:
        "Win more clients and manage pipelines efficiently with AI-powered CRM workflows. Find out how AI within CRM helps sales representatives build trust and move faster.",
    },
    {
      tabContent: [
        {
          title: "Trial onboarding automation",
          content: "Send feature tips and guides post-sign-up using AssistAI.",
          alt: "AI Sales CRM for SaaS",
        },
        {
          title: "Lead scoring",
          content:
            "AI ranks prospects based on usage behaviour and engagement level.",
          alt: "AI Sales CRM for SaaS",
        },
        {
          title: "Integrated chat support",
          content: "Handle product questions directly within the CRM.",
          alt: "AI Sales CRM for SaaS",
        },
        {
          title: "Upsell reminders",
          content:
            "Get notified when users reach plan limits or upgrade potential.",
          alt: "AI Sales CRM for SaaS",
        },
        {
          title: "Forecasting growth",
          content:
            "Use predictive analytics to estimate MRR and conversion trends.",
          alt: "AI Sales CRM for SaaS",
        },
      ],
      img: realWorldImg5,
      alt: "AI Sales CRM for SaaS",
      subtitle:
        "Convert more trials into paid users with timely engagement and smart automation. Leverage AI sales CRM to drive conversions and deliver proactive support.",
    },
  ];

  const faqs = [
    {
      question: "What is an AI CRM for sales?",
      answer:
        "An AI CRM for sales uses artificial intelligence to manage leads, automate tasks, and assist sales reps with smart suggestions, summaries, and chat automation.",
    },
    {
      question: "How does AI within CRM help sales representatives?",
      answer:
        "It saves time by automating repetitive tasks, writing follow-ups, summarising chats, and helping reps prioritise leads with AI-powered scoring.",
    },
    {
      question: "Is Pepper Cloud suitable for small businesses?",
      answer:
        "Yes, Pepper Cloud is built for small and medium teams, with scalable plans, intuitive design, and 24/7 support.",
    },
    {
      question: "Can I use Pepper Cloud on mobile?",
      answer:
        "Absolutely. Pepper Cloud’s mobile app lets you manage deals, customers, and chats on the go.",
    },
    {
      question: "What integrations does Pepper Cloud support?",
      answer:
        "You can plug in tools like Gmail, Zoom, Outlook, Mailchimp, Aircall, Xero, and more with just a few clicks.",
    },
    {
      question: "How does AI within CRM help sales?",
      answer:
        "AI within CRM automates tasks, prioritises leads, and offers real-time insights to help sales reps focus on closing deals. It boosts productivity and improves follow-ups using smart recommendations.",
    },
    {
      question: "Which AI tool is best for sales?",
      answer:
        "Pepper Cloud is the best AI CRM for sales, offering AssistAI, omnichannel messaging, and predictive insights. It’s built for teams that want to sell smarter and faster.",
    },
  ];

  const bentoDetails1 = [
    {
      title: "Easy to use",
      desc: "Clean, clutter-free design and a short learning curve make it ideal for fast-moving teams.",
      img: bentoImg1,
    },
    {
      title: "Enterprise-level security",
      desc: "PDPA-compliant CRM, built to keep your customer data safe.",
      img: bentoImg2,
    },
  ];

  const bentoDetails2 = [
    {
      title: "Seamless integration",
      desc: "Connects smoothly with WhatsApp, email, and calls so all your communication stays in one place.",
      img: bentoImg3,
      alt: "Seamless integration with WhatsApp, email, and calls",
    },
  ];

  const bentoDetails3 = [
    {
      title: "Advanced sales dashboards",
      desc: "Real-time performance tracking, forecasting, and insights to help you make informed decisions.",
      img: bentoImg4,
      alt: "Advanced sales dashboards with real-time sales and performance tracking",
    },
    {
      title: "Custom-built AI",
      desc: "Our AI models are tuned to understand your sales cycle and deliver smarter suggestions.",
      img: bentoImg5,
      alt: "AI built for CRM",
      mobImg: bentoImg5Mob,
      mobAlt: "Custom built AI by Pepper Cloud",
    },
  ];

  const partners = [
    { icon: partnerIcon1, alt: "caffeine solutions - Pepper Cloud Customer" },
    { icon: partnerIcon2, alt: "cuscapi - Pepper Cloud Customer" },
    { icon: partnerIcon3, alt: "TechData - Pepper Cloud Customer" },
    { icon: partnerIcon5, alt: "sis - Pepper Cloud Customer" },
    {
      icon: partnerIcon6,
      alt: "mustard seed systems corporation - Pepper Cloud Customer",
    },
    {
      icon: partnerIcon7,
      alt: "Singapore Maritime Foundation - Pepper Cloud Customer",
    },
    { icon: partnerIcon8, alt: "urban moods - Pepper Cloud Customer" },
    { icon: partnerIcon1, alt: "caffeine solutions - Pepper Cloud Customer" },
    { icon: partnerIcon2, alt: "cuscapi - Pepper Cloud Customer" },
    { icon: partnerIcon3, alt: "TechData - Pepper Cloud Customer" },
    { icon: partnerIcon5, alt: "sis - Pepper Cloud Customer" },
    {
      icon: partnerIcon6,
      alt: "mustard seed systems corporation - Pepper Cloud Customer",
    },
    {
      icon: partnerIcon7,
      alt: "Singapore Maritime Foundation - Pepper Cloud Customer",
    },
    { icon: partnerIcon8, alt: "urban moods - Pepper Cloud Customer" },
  ];

  const swiperCards = [
    {
      icon: swiperIcon1,
      heading: "Conversational intelligence",
      contentOne: "Auto-respond to customer queries and FAQs with AI chatbot.",
      gradientOne: "linear-gradient(358deg, #F48446 1.56%, #783CA8 98.76%)",
      gradientTwo: "linear-gradient(358deg, #BA0038 1.56%, #F48446 98.76%)",
    },
    {
      icon: swiperIcon2,
      heading: "Smart workflows",
      contentOne: "Automate lead capture, follow-ups, and task assignments.",
      gradientOne: "linear-gradient(180deg, #2788E7 0%, #783CA8 100%)",
      gradientTwo: "linear-gradient(358deg, #BA0038 1.56%, #F48446 98.76%)",
    },
    {
      icon: swiperIcon3,
      heading: "Intent detection",
      contentOne: "Understand what customers are asking, even in chat",
      gradientOne: "linear-gradient(180deg, #053333 0%, #009A99 100%)",
      gradientTwo: "linear-gradient(358deg, #BA0038 1.56%, #F48446 98.76%)",
    },
    {
      icon: swiperIcon4,
      heading: "Real-time analytics",
      contentOne:
        "Track sales opportunities and team performance in real time. ",
      gradientOne: "linear-gradient(2deg, #09939A -8.7%, #783CA8 79.59%)",
      gradientTwo: "linear-gradient(358deg, #BA0038 1.56%, #F48446 98.76%)",
    },
  ];

  const carouseText = [
    "Real-time AI insights",
    "Unified communication",
    "Smart sales automation",
  ];

  return (
    <main>
      <SEO
        title={"AI Sales CRM for Teams | Pepper Cloud"}
        pathname={"https://peppercloud.com/ai-sales-crm-with-smart-automation/"}
        keywords="AI sales CRM,AI for sales and CRM,Best AI CRM for sales,CRM AI for sales,How does AI within crm help sales representative"
        description={
          "Boost productivity with Pepper Cloud’s AI CRM for sales. Automate tasks, improve lead follow-ups, and close deals faster across all channels."
        }
        ogData={{
          "og:image": [
            "/meta/og/1X1/home.png",
            "/meta/og/1024X512/home.png",
            "/meta/og/1200X630/home.png",
          ],
        }}
        jsonLd={[
          {
            "@context": "https://schema.org",
            "@type": "Organization",
            name: "Pepper Cloud",
            legalName: "Pepper Cloud PTE LTD",
            url: "https://peppercloud.com/",
            logo: "https://peppercloud.com/icons/logo.png",
            foundingDate: "2017",
            address: [
              {
                "@type": "PostalAddress",
                streetAddress: "#04-01/02",
                addressLocality: "Blk 79 Ayer Rajah Crescent",
                addressRegion: "SG",
                postalCode: "139955",
                addressCountry: "Singapore",
              },
              {
                "@type": "PostalAddress",
                streetAddress:
                  "2nd Floor, Salarpuria Tower 1, 7th Block Koramangala",
                addressLocality: "Bengaluru",
                addressRegion: "KA",
                postalCode: "560095",
                addressCountry: "India",
              },
            ],
            contactPoint: {
              "@type": "ContactPoint",
              contactType: "customer support",
              telephone: "+6566562616",
              email: ["sales@peppercloud.com", "support@peppercloud.com"],
            },
            sameAs: [
              "https://twitter.com/peppercloudpte",
              "https://www.linkedin.com/company/peppercloud/",
              "https://www.facebook.com/PepperCloudPteLtd",
              "https://www.instagram.com/pepper.cloud/",
            ],
          },
          {
            "@context": "https://schema.org/",
            "@type": "FAQPage",
            mainEntity: [
              {
                "@type": "Question",
                name: "What is an AI CRM for sales?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "An AI CRM for sales uses artificial intelligence to manage leads, automate tasks, and assist sales reps with smart suggestions, summaries, and chat automation.",
                },
              },
              {
                "@type": "Question",
                name: "How does AI within CRM help sales representatives?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "It saves time by automating repetitive tasks, writing follow-ups, summarising chats, and helping reps prioritise leads with AI-powered scoring.",
                },
              },
              {
                "@type": "Question",
                name: "Is Pepper Cloud suitable for small businesses?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Yes, Pepper Cloud is built for small and medium teams, with scalable plans, intuitive design, and 24/7 support.",
                },
              },
              {
                "@type": "Question",
                name: "Can I use Pepper Cloud on mobile?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Absolutely. Pepper Cloud’s mobile app lets you manage deals, customers, and chats on the go.",
                },
              },
              {
                "@type": "Question",
                name: "What integrations does Pepper Cloud support?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "You can plug in tools like Gmail, Zoom, Outlook, Mailchimp, Aircall, Xero, and more with just a few clicks.",
                },
              },
              {
                "@type": "Question",
                name: "How does AI within CRM help sales?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "AI within CRM automates tasks, prioritises leads, and offers real-time insights to help sales reps focus on closing deals. It boosts productivity and improves follow-ups using smart recommendations.",
                },
              },
              {
                "@type": "Question",
                name: "Which AI tool is best for sales?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Pepper Cloud is the best AI CRM for sales, offering AssistAI, omnichannel messaging, and predictive insights. It’s built for teams that want to sell smarter and faster.",
                },
              },
            ],
          },
        ]}
      />
      <div className={classes.mainSection}>
        <section className={classes.heroSection}>
          <div className="container">
            <div className={classes.heroSectionContainer}>
              <div className={classes.leftContainer}>
                <div className={classes.leftHeader}>
                  <Swiper
                    className={classes.textSlider}
                    slidesPerView="auto"
                    spaceBetween={0}
                    // centeredSlides
                    loop={true}
                    speed={3000}
                    modules={[Autoplay]}
                    allowTouchMove={false} // Global setting for no touch move
                    autoplay={{
                      delay: 100,
                      disableOnInteraction: false,
                      pauseOnMouseEnter: false, // Ensure it doesn't pause on mouse enter globally
                    }}
                    breakpoints={{
                      // For smaller screens (mobile)
                      0: {
                        freeMode: true,
                        grabCursor: false,
                        allowTouchMove: true, // Allow touch move on mobile
                        spaceBetween: 0,
                      },
                      // For larger screens (desktop)
                      768: {
                        freeMode: true, // Set to true for continuous, non-snapping marquee effect
                        autoplay: {
                          delay: 0,
                          disableOnInteraction: false,
                          pauseOnMouseEnter: false, // Crucial: Ensure it does not pause on hover
                        },
                        // speed: 3000,
                        loop: true,
                        allowTouchMove: false, // Disable touch move for desktop marquee behavior
                      },
                    }}
                  >
                    {carouseText.map((text) => (
                      <SwiperSlide className={classes.carouselSlide}>
                        <p
                          className={clsx(
                            classes.carouselText,
                            "font-16",
                            "font-wix-semibold"
                          )}
                        >
                          {text}
                        </p>
                        <div className={classes.dot} />
                      </SwiperSlide>
                    ))}
                  </Swiper>
                </div>
                <div className={classes.leftBody}>
                  <motion.h1
                    initial={{ opacity: 1, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.3 }}
                    className="font-wix-semibold font-64 font-white"
                  >
                    AI Sales CRM for <span>smarter, faster</span> selling
                  </motion.h1>
                  <p className="font-white font-20 font-wix-regular mb20">
                    Close deals faster, automate busywork, and connect with
                    customers smarter. Explore and experience Pepper Cloud
                    intelligent AI CRM designed for growing businesses.
                  </p>
                  <Link
                    className="primaryButton font-20 font-wix-medium font-white "
                    to="/contact/"
                  >
                    Book a free demo
                  </Link>
                </div>
                <div className={classes.leftFooter}>
                  <section className={classes.stripSection}>
                    <motion.h3
                      initial={{ opacity: 1, y: 20 }}
                      whileInView={{ opacity: 1, y: 0 }}
                      transition={{ duration: 0.3 }}
                      className="font-wix-medium font-20 font-white"
                    >
                      Trusted by leading businesses for outstanding efficiency
                    </motion.h3>
                    <Swiper
                      className={classes.partnerSlider}
                      slidesPerView="auto"
                      spaceBetween={30}
                      loop={true}
                      speed={3000}
                      modules={[Autoplay]}
                      allowTouchMove={false}
                      autoplay={{
                        delay: 100,
                        disableOnInteraction: false,
                        pauseOnMouseEnter: false,
                      }}
                      breakpoints={{
                        // For smaller screens (mobile)
                        0: {
                          freeMode: true,
                          grabCursor: false,
                          allowTouchMove: true,
                          spaceBetween: 20,
                        },
                        // For larger screens (desktop)
                        768: {
                          freeMode: false,
                          autoplay: {
                            delay: 100,
                            disableOnInteraction: false,
                            pauseOnMouseEnter: true,
                          },
                          speed: 3000,
                          loop: true,
                          allowTouchMove: true,
                        },
                      }}
                    >
                      {partners.map((partner) => (
                        <SwiperSlide className={classes.partnerSlide}>
                          <img src={partner.icon} alt={partner.alt} />
                        </SwiperSlide>
                      ))}
                    </Swiper>
                  </section>
                </div>
              </div>
              <div className={classes.rightContainer}>
                <LazyImage source={heroSectionImg} width={"100%"} />
              </div>
            </div>
          </div>
        </section>
        <section className={clsx(classes.detailSection, "section1")}>
          <div className="container">
            <div className={classes.detailCard}>
              <div className={classes.detailCardLeft}>
                <LazyImage width={"100%"} source={detailImg1} />
              </div>
              <div className={classes.detailCardRight}>
                <motion.h2
                  initial={{ opacity: 1, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.3 }}
                  className="font-wix-semibold font-56 font-white"
                >
                  What is AI CRM for sales teams?
                </motion.h2>
                <motion.p
                  initial={{ opacity: 0, x: -20 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  transition={{ duration: 0.3 }}
                  className="font-wix-regular font-18 font-white"
                >
                  AI sales CRM combines the power of artificial intelligence
                  with customer relationship management tools to support sales
                  teams. It goes beyond storing customer data. It helps sales
                  reps understand customer behaviour, predict outcomes, and
                  automate routine tasks.
                </motion.p>
                <motion.p
                  initial={{ opacity: 0, x: -20 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  transition={{ duration: 0.3 }}
                  className="font-wix-regular font-18 font-white"
                >
                  With CRM AI for sales, you don’t just manage leads—you grow
                  them with intelligence. The system learns from interactions
                  and provides actionable insights to make every conversation
                  more effective.
                </motion.p>
              </div>
            </div>
          </div>
        </section>
        <section className={classes.detailSection}>
          <div className="container">
            <div className={classes.detailCard}>
              <div className={classes.detailCardRight}>
                <motion.h2
                  initial={{ opacity: 1, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.3 }}
                  className="font-wix-semibold font-56 font-white"
                >
                  Key features of AI sales CRM
                </motion.h2>
                <motion.p
                  initial={{ opacity: 0, x: -20 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  transition={{ duration: 0.3 }}
                  className="font-wix-regular font-18 font-white"
                >
                  Pepper Cloud CRM software brings advanced AI for sales,
                  designed to boost productivity and performance.
                </motion.p>
              </div>
              <div className={clsx(classes.detailCardLeft, "card2")}>
                {swiperCards.map((card) => (
                  <div
                    className={classes.swiperCard}
                    style={{ background: card.gradientOne }}
                  >
                    <div className="mainCard">
                      <img src={card.icon} />
                      <h4 className="font-20 font-white font-wix-semibold">
                        {card.heading}
                      </h4>
                      <p className="font-16 font-white font-wix-regular">
                        {card.contentOne}
                      </p>
                    </div>
                    <div className="hoverCard">
                      <p className="font-16 font-white font-wix-regular">
                        {card.contentOne}
                      </p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>
        <section className={clsx(classes.detailSection, "section3")}>
          <div className="container">
            <div className={clsx(classes.detailCard, "detailCard3")}>
              <div className={classes.detailCardLeft}>
                <LazyImage width={"100%"} source={detailImg2} />
              </div>
              <div className={classes.detailCardRight}>
                <motion.p
                  initial={{ opacity: 1, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.3 }}
                  className="font-wix-semibold font-20 font-white"
                >
                  AssistAI
                </motion.p>
                <motion.h2
                  initial={{ opacity: 1, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.3 }}
                  className="font-wix-semibold font-56 font-white"
                >
                  One system, endless smart actions
                </motion.h2>
                <motion.p
                  initial={{ opacity: 0, x: -20 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  transition={{ duration: 0.3 }}
                  className="font-wix-regular font-18 font-white"
                >
                  From sentiment tagging to workflow triggers, let AI handle the
                  repetitive stuff. You focus on decisions — your CRM takes care
                  of the data.
                </motion.p>
              </div>
            </div>
          </div>
        </section>
      </div>

      <section className={classes.bentoSection}>
        <div className="container">
          <div className={classes.bentoSectionHeader}>
            <div className={classes.bentoSectionHeaderLeft}>
              <motion.h2
                initial={{ opacity: 1, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.3 }}
                className="font-wix-semibold font-56 color-black1"
              >
                Pepper Cloud: The best AI CRM for sales teams
              </motion.h2>
            </div>
            <div className={classes.bentoSectionHeaderRight}>
              <motion.p
                initial={{ opacity: 1, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.3 }}
                className="font-wix-regular font-18 color-black2"
              >
                Pepper Cloud is a powerful, easy-to-use AI sales CRM that helps
                your team sell faster and smarter. Built for modern sales teams,
                it combines automation, insights, and communication in one
                platform.
              </motion.p>
            </div>
          </div>
          <div className={classes.bentoSectionContainer}>
            <div className={classes.bentoTab}>
              {bentoDetails1.map((bentoDetail, index) => (
                <div className={clsx(classes.bentoCard, `card${index + 1}`)}>
                  <p className="font-24 font-black1 font-wix-semibold">
                    {bentoDetail.title}
                  </p>
                  <p className="font-16 font-black1 font-wix-regular">
                    {bentoDetail.desc}
                  </p>
                  <img alt={bentoDetail.alt} src={bentoDetail.img} />
                </div>
              ))}
            </div>
            <div className={classes.bentoTab}>
              {bentoDetails2.map((bentoDetail, index) => (
                <div className={clsx(classes.bentoCard, `card3`)}>
                  <p className="font-24 font-black1 font-wix-semibold">
                    {bentoDetail.title}
                  </p>
                  <p className="font-16 font-black1 font-wix-regular">
                    {bentoDetail.desc}
                  </p>
                  <img alt={bentoDetail.alt} src={bentoDetail.img} />
                </div>
              ))}
            </div>
            <div className={classes.bentoTab}>
              {bentoDetails3.map((bentoDetail, index) => (
                <div className={clsx(classes.bentoCard, `card${index + 4}`)}>
                  <div className="cardInner">
                    <p className="font-24 font-black1 font-wix-semibold">
                      {bentoDetail.title}
                    </p>
                    <p className="font-16 font-black1 font-wix-regular">
                      {bentoDetail.desc}
                    </p>
                  </div>
                  <img alt={bentoDetail.alt} src={bentoDetail.img} className="webImg" />
                  {bentoDetail.mobImg && (
                    <img
                      alt={bentoDetail.mobAlt}
                      src={bentoDetail.mobImg}
                      className="mobImg"
                    />
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
      <section className={classes.benfitSection}>
        <div className="container">
          <div className={classes.aiSectionLeft}>
            <div className="sectionTag">
              <p className="font-18  font-wix-semibold color-blue1">Benefits</p>
            </div>
            <motion.h2
              initial={{ opacity: 1, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
              className="font-wix-semibold font-56 color-black1"
            >
              Benefits of using AI CRM for sales teams
            </motion.h2>
            <motion.p
              initial={{ opacity: 1, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
              className="font-wix-regular font-18 color-black2"
            >
              Choosing an AI sales CRM like Pepper Cloud brings measurable
              improvements in performance, efficiency, and customer engagement.
            </motion.p>
          </div>
        </div>
        <div className={classes.benfitListContainer}>
          {benfitList.map((listItem, index) => (
            <div
              className={clsx(
                classes.benfitListItemOuter,
                "benfitListItemOuter",
                activeView === index ? "active" : ""
              )}
              onMouseOver={() => setActveView(index)}
              style={{
                "--hover-bg-color": listItem.bgColor,
              }}
            >
              <div className={classes.benfitListItem}>
                <LazyImage
                  source={listItem.icon}
                  className={classes.benfitIcon}
                  alt={listItem.alt}
                />
                <div className={classes.benfitListItemContent}>
                  <p className="font-wix-semibold font-20 color-black1">
                    {listItem.heading}
                  </p>
                  <p className="font-wix-regular font-16 color-black2">
                    {listItem.content}
                  </p>
                </div>

                <img
                  alt={listItem.alt}
                  className={classes.absoluteImage}
                  src={listItem.image}
                />
              </div>
            </div>
          ))}
        </div>
      </section>
      <section className={classes.tabsSection}>
        <div className={classes.absoulteCard}>
          <TruestedSection shadow={true} background={true} />
        </div>
        <div className="container">
          <div className="centerContainer">
            <motion.h2
              initial={{ opacity: 1, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
              className="font-wix-semibold font-56 color-black1"
            >
              Application and use cases of CRM for sales teams
            </motion.h2>
            <div className={classes.tabsContainer}>
              <div
                className={clsx(
                  classes.tab,
                  "font-wix-medium",
                  "font-20",
                  activeRealWorld === 0 && "active"
                )}
                onClick={() => setActiveRealWorld(0)}
              >
                Healthcare
              </div>
              <div
                className={clsx(
                  classes.tab,
                  "font-wix-medium",
                  "font-20",
                  activeRealWorld === 1 && "active"
                )}
                onClick={() => setActiveRealWorld(1)}
              >
                Real estate
              </div>
              <div
                className={clsx(
                  classes.tab,
                  "font-wix-medium",
                  "font-20",
                  activeRealWorld === 2 && "active"
                )}
                onClick={() => setActiveRealWorld(2)}
              >
                Education
              </div>
              <div
                className={clsx(
                  classes.tab,
                  "font-wix-medium",
                  "font-20",
                  activeRealWorld === 3 && "active"
                )}
                onClick={() => setActiveRealWorld(3)}
              >
                Professional services
              </div>
              <div
                className={clsx(
                  classes.tab,
                  "font-wix-medium",
                  "font-20",
                  activeRealWorld === 4 && "active"
                )}
                onClick={() => setActiveRealWorld(4)}
              >
                SaaS & Tech
              </div>
            </div>
          </div>
          <div className={classes.tabCard}>
            <div className={classes.tabCardLeftContainer}>
              {tabContentData.map(
                (listItem, index) =>
                  index === activeRealWorld && (
                    <div>
                      <motion.p
                        initial={{ opacity: 0, x: -20 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        transition={{ duration: 0.3 }}
                        className="font-wix-regular font-18 font-black1"
                      >
                        {listItem.subtitle}
                      </motion.p>
                      <div className={classes.tabListContainer}>
                        {listItem.tabContent.map((item) => (
                          <motion.div
                            initial={{ opacity: 0, x: -20 }}
                            whileInView={{ opacity: 1, x: 0 }}
                            transition={{ duration: 0.3 }}
                            className={classes.tabListItem}
                          >
                            <LazyImage
                              source={greenCheckCircle}
                              className={classes.tabIcon}
                              alt={item.alt}
                            />
                            <div className={classes.tabListItemContent}>
                              <p className="font-wix-semibold font-18 font-black1">
                                {item.title}:
                              </p>
                              <p className="font-wix-regular font-16 font-black1">
                                {item.content}
                              </p>
                            </div>
                          </motion.div>
                        ))}
                      </div>
                    </div>
                  )
              )}
            </div>
            <div className={classes.tabCardRightContainer}>
              {tabContentData.map(
                (listItem, index) =>
                  index === activeRealWorld && (
                    <motion.div
                      initial={{ opacity: 1, y: 20 }}
                      whileInView={{ opacity: 1, y: 0 }}
                      transition={{ duration: 0.3 }}
                      // className={classes.aiSectionRight}
                    >
                      <LazyImage
                        source={listItem.img}
                        alt={listItem.alt}
                        width={"100%"}
                      />
                    </motion.div>
                  )
              )}
            </div>
          </div>
        </div>
      </section>

      <div className={classes.wpFaq}>
        <FaqSection
          backgroundColor={"#FFFFFF"}
          heading={"Frequently asked questions"}
          faqs={faqs}
        />
      </div>
      <section className={classes.commonPageFooterSection}>
        <div className="container">
          <div className="centerContainer">
            <motion.h2
              className="font-wix-medium font-56 font-white"
              initial={{ opacity: 1, y: 30 }}
              transition={{ duration: 0.5 }}
              whileInView={{ opacity: 1, y: 0 }}
            >
              Accelerate your sales with AI that works.
            </motion.h2>
            <Link
              className="primaryButton font-20 font-wix-medium font-white"
              to="/contact/?utm_source=WhatsApp+CRM&utm_medium=Get+started"
            >
              Get started
            </Link>
          </div>
        </div>
      </section>
    </main>
  );
};

export default AiSalesCrm;
